<template>
  <section class="section-detail-class-school">
    <div class="ss-breadcrumb">
      <div class="container-hts">
        <ul class="margin-0 p-0">
          <li><router-link to="/lop-hoc">Lớp học</router-link></li>
          <li>
            <router-link to="">{{ nameClass }}</router-link>
          </li>
        </ul>
      </div>
    </div>
    <div class="container">
      <div class="row col-md-12">
        <div class="col-md-8 header-detail-class-school pl-0">
          <div class="title-class-school pt-4">
            <strong>
              <h3>{{ nameClass }}</h3>
            </strong>
          </div>
          <div class="title-name-school">
            Giáo viên: {{ dataClassSchool.teacherName }}
          </div>
        </div>

        <div class="col-md-4 header-detail-class-school pr-0" style="text-align: right">
          <div class="title-class-school" style="padding-top: 2.5rem !important">
            Sĩ số: {{ dataClassSchool.countMember }}
          </div>
          <div class="title-name-school">
            Trường học: {{ dataClassSchool.nameSchool }}
          </div>
        </div>
      </div>

      <b-tabs class="pre-class-school-list__filter__tabs">
        <b-tab title="Danh sách học sinh" @click="changeTab(true)" :active="isTabMember">
          <TabMember v-if="isTabMember" />
        </b-tab>
        <b-tab title="Danh sách nhóm" @click="changeTab(false)" :active="!isTabMember">
          <TabGroup v-if="!isTabMember" />
        </b-tab>
      </b-tabs>
    </div>
  </section>
</template>
<script>
import { getAuth } from "@/utils/jwt";
import { ROLE_TEACHER, ROLE_PUPIL } from "@/store/auth/constants";
import { getDetail } from "./../_api/classSchoolServices";
import TabMember from "./_components/TabMember.vue";
import TabGroup from "./_components/TabGroup.vue";
export default {
  components: {
    TabMember,
    TabGroup,
  },
  data() {
    return {
      isTabMember: true,
      classSchoolId: 0,
      nameClass: "",
      dataClassSchool: {
        id: 0,
        nameSchool: "",
        code: "",
        name: "",
        password: "",
        classId: "",
        subjectId: "",
        teacherName: "",
        countMember: 0,
      },
      authInfo: getAuth(),
      roleTeacher: ROLE_TEACHER,
      roleHocSinh: ROLE_PUPIL,
    };
  },
  mounted() {
    this.nameClass = this.$router.history.current.query.nameClass;
    if (this.authInfo.roleCode == this.roleHocSinh) {
      this.$router.push("/danh-sach-lop-hoc");
    }
    this.classSchoolId = this.$route.query.id;
    if (this.classSchoolId) {
      this.getDetailClassSchool();
    }
  },
  methods: {
    changeTab(tab) {
      this.isTabMember = tab;
    },
    getDetailClassSchool() {
      let self = this;
      getDetail(this.classSchoolId).then((res) => {
        if (res && res.data && !res.errors) {
          self.dataClassSchool = {
            id: res.data.id,
            nameSchool: res.data.nameSchool,
            code: res.data.code,
            name: res.data.name,
            password: res.data.password,
            classId: res.data.classId,
            subjectId: res.data.subjectId,
            subjectName: res.data.subjectName,
            teacherName: res.data.teacherName,
            countMember: res.data.countMember,
          };
        }
      });
    },
  },
};
</script>
